import { makeStyles } from '@material-ui/core'

import React from 'react'
import { FilterChip } from 'asterX-UI/Inputs'

import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'

const useStyle = makeStyles(theme => ({
  rootDiv: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  }
}))

const Filter = () => {
  const { workListStore, workListStoreFunc } = useWorkListStoreManager()

  const classes = useStyle()
  const maxWidth = window.innerWidth - 16

  return (
    <div className={classes.rootDiv} style={{ maxWidth }}>
      <FilterChip
        type={'INPUT'}
        label={'РЛ'}
        value={workListStore.filter.globalId}
        name={'globalId'}
        textType={'number'}
        onChange={workListStoreFunc.onChangeFilter}
      />

      <FilterChip
        type={'INPUT'}
        label={'VIN-код'}
        value={workListStore.filter.vin}
        name={'vin'}
        onChange={workListStoreFunc.onChangeFilter}
      />

      <FilterChip
        type={'INPUT'}
        label={'Телефон'}
        value={workListStore.filter?.client?.phoneNumber}
        name={'phoneNumber'}
        onChange={workListStoreFunc.onChangeFilter}
      />

      <FilterChip
        type={'INPUT'}
        label={'Имя'}
        value={workListStore.filter?.client?.firstName}
        name={'firstName'}
        onChange={workListStoreFunc.onChangeFilter}
      />

      <FilterChip
        type="SELECT"
        label="Вид оплаты"
        value={workListStore.filter.saleType}
        name="saleType"
        options={['Кредит', 'Прямая', 'Trade-In']}
        onChange={workListStoreFunc.onChangeFilter}
      />

      <FilterChip
        type={'RANGE_DATE'}
        label={'по дате создания'}
        name="createdDate"
        onChange={workListStoreFunc.onChangeFilter}
        value={{
          from: workListStore?.filter?.createdDateFrom || null,
          to: workListStore?.filter?.createdDateTo || null
        }}
      />

      <FilterChip
        type={'RANGE_DATE'}
        label={'по дате обновления'}
        name="updatedDate"
        onChange={workListStoreFunc.onChangeFilter}
        value={{
          from: workListStore?.filter?.updatedDateFrom || null,
          to: workListStore?.filter?.updatedDateTo || null
        }}
      />

      <FilterChip
        label="Статус перевода с Октелл"
        name="callResult"
        type="SELECT"
        options={[
          'Клиент думает',
          'Встреча назначена',
          'Перевод звонка',
          'Срочно связаться'
        ]}
        value={workListStore.filter.callResult}
        onChange={workListStoreFunc.onChangeFilter}
      />

      <FilterChip
        label="Номер обращения"
        type="INPUT"
        name="contactId"
        textType="number"
        value={workListStore.filter.contactId}
        onChange={workListStoreFunc.onChangeFilter}
      />
    </div>
  )
}

export default Filter
